var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19961 10.2016H2.99961C1.67413 10.2016 0.599609 9.12705 0.599609 7.80156V3.00156C0.599609 1.67608 1.67413 0.601562 2.99961 0.601562H10.9996C12.3251 0.601562 13.3996 1.67608 13.3996 3.00156V7.80156C13.3996 9.12705 12.3251 10.2016 10.9996 10.2016H7.79961V11.8016H9.39961C9.84144 11.8016 10.1996 12.1597 10.1996 12.6016C10.1996 13.0434 9.84144 13.4016 9.39961 13.4016H4.59961C4.15778 13.4016 3.79961 13.0434 3.79961 12.6016C3.79961 12.1597 4.15778 11.8016 4.59961 11.8016H6.19961V10.2016ZM10.9996 2.20156H2.99961C2.55778 2.20156 2.19961 2.55973 2.19961 3.00156V7.80156C2.19961 8.24339 2.55778 8.60156 2.99961 8.60156H10.9996C11.4414 8.60156 11.7996 8.24339 11.7996 7.80156V3.00156C11.7996 2.55973 11.4414 2.20156 10.9996 2.20156Z",
    fill: "#292F49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.f2baac66fd35b4d2037b92e575877fe4.svg";
export { ForwardRef as ReactComponent };